import { useTranslation } from '@ufc/core'
import { Download } from '@ufc/uikit'
import { PageHeader } from '@ufc/uikit'
import type { ShipmentsHeaderProps } from '../types'

export function ShipmentsHeader({ isArabic, onExport }: ShipmentsHeaderProps) {
  const { t } = useTranslation()

  return (
    <PageHeader
      title={t('shipments.title')}
      subtitle={t('shipments.subtitle')}
      isRTL={isArabic}
      actions={[
        {
          label: t('common.export'),
          icon: Download,
          onClick: onExport,
          variant: 'outline',
        },
      ]}
    />
  )
}
